import { Component, OnInit , EventEmitter , Input } from '@angular/core';
import { Router} from '@angular/router'
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  
 @Input() public isUserLoggedIn: boolean;
  constructor(private router:Router) { }

  ngOnInit() {
  }
 public onFeedbackClick(){
        this.router.navigate(['login']);
    }

 public onInterviewClick(){
        this.router.navigate(['interview']);
    }
}



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/header/header.component.ts